import ArcAccessibility from './ArcAccessibility.js';
customElements.define('arc-accessibility', ArcAccessibility);
